/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AlertsAndReportsFormQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AlertsAndReportsFormQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly websitesAlerts: ReadonlyArray<{ readonly __typename?: 'WebsitesAlerts', readonly websiteId: CK.WebsiteId, readonly alerts: boolean, readonly reports: boolean }> } | null };


export const AlertsAndReportsFormDocument = gql`
    query AlertsAndReportsForm($accountId: AccountId!) {
  account(id: $accountId) {
    id
    websitesAlerts {
      websiteId
      alerts
      reports
    }
  }
}
    `;

/**
 * __useAlertsAndReportsFormQuery__
 *
 * To run a query within a React component, call `useAlertsAndReportsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsAndReportsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsAndReportsFormQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAlertsAndReportsFormQuery(baseOptions: Apollo.QueryHookOptions<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables> & ({ variables: AlertsAndReportsFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables>(AlertsAndReportsFormDocument, options);
      }
export function useAlertsAndReportsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables>(AlertsAndReportsFormDocument, options);
        }
export function useAlertsAndReportsFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables>(AlertsAndReportsFormDocument, options);
        }
export type AlertsAndReportsFormQueryHookResult = ReturnType<typeof useAlertsAndReportsFormQuery>;
export type AlertsAndReportsFormLazyQueryHookResult = ReturnType<typeof useAlertsAndReportsFormLazyQuery>;
export type AlertsAndReportsFormSuspenseQueryHookResult = ReturnType<typeof useAlertsAndReportsFormSuspenseQuery>;
export type AlertsAndReportsFormQueryResult = Apollo.QueryResult<AlertsAndReportsFormQuery, AlertsAndReportsFormQueryVariables>;